module.exports = __webpack_public_path__ + "img/vip.edd3246c.png";